module.exports = __webpack_public_path__ + "static/media/2.d9ae73c8.svg";